// removed by extract-text-webpack-plugin
module.exports = {"Skills":"Skills___1ErfX","h1":"h1___VI31l","h2":"h2___dtg4v","p":"p___3s7Ox","profile":"profile___1BwXi","ul":"ul___2aMiE","li":"li___2m_VA","link":"link___3gMqf","img":"img___2KjxA"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Skills/style.scss
// module id = 120
// module chunks = 0